import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

const MARGIN = 24;
const PAGE_BACKGROUND = '#f8fafc';

/** Renders a DOM node to a multi-page, letter-sized PDF and triggers a download. */
export async function exportElementToPdf(element: HTMLElement, fileName: string): Promise<void> {
  const canvas = await html2canvas(element, {
    scale: Math.min(2, window.devicePixelRatio || 1) * 1.5,
    backgroundColor: PAGE_BACKGROUND,
    useCORS: true,
    logging: false,
    windowWidth: element.scrollWidth,
  });

  const pdf = new jsPDF({ orientation: 'portrait', unit: 'pt', format: 'letter' });
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const renderWidth = pageWidth - MARGIN * 2;
  const renderHeight = pageHeight - MARGIN * 2;

  const scale = renderWidth / canvas.width;
  const sliceHeight = Math.floor(renderHeight / scale);

  const slice = document.createElement('canvas');
  const context = slice.getContext('2d');
  if (!context) throw new Error('Canvas is unavailable in this browser.');

  let sourceY = 0;
  let pageIndex = 0;

  while (sourceY < canvas.height) {
    const currentHeight = Math.min(sliceHeight, canvas.height - sourceY);
    slice.width = canvas.width;
    slice.height = currentHeight;
    context.fillStyle = PAGE_BACKGROUND;
    context.fillRect(0, 0, slice.width, slice.height);
    context.drawImage(canvas, 0, sourceY, canvas.width, currentHeight, 0, 0, canvas.width, currentHeight);

    if (pageIndex > 0) pdf.addPage();
    pdf.addImage(slice.toDataURL('image/png'), 'PNG', MARGIN, MARGIN, renderWidth, currentHeight * scale);

    sourceY += currentHeight;
    pageIndex += 1;
  }

  pdf.save(fileName);
}
